import React, { useState } from "react";
import "./style.css";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import AccountDataPanel from "./AccountDataPanel";
import useMyAccount from "./hooks/useMyAccount";
import AccountDocPanel from "./AccountDocPanel";
import AccountCardPanel from "./AccountCardPanel";

const MyAccount: React.FC = () => {
  const isDesktop = useDesktopSize();
  const [ticketsTabActive, setTicketsTabActive] = useState(0);
  useMyAccount();

  return (
    <div className={isDesktop ? "panel-account" : "panel-account-mobile"}>
      <AccountDataPanel ticketsTabActive={ticketsTabActive} setTicketsTabActive={setTicketsTabActive} />
      <AccountCardPanel />
      <AccountDocPanel ticketsTabActive={ticketsTabActive} />
    </div>
  );
};

export default MyAccount;
